// Copyright (c) 2026 Celadonsoft
// All rights reserved.

import { mapGetters } from 'vuex';

import { buildProductRating, buildPassOffers } from '@utils/structured-data';

// Facts about the pass that several pages can contribute, gathered in one
// place because the pages that show them are not fixed: the price table and
// the rating arrive through shared blocks the CMS switches on and off per
// page. Each computed returns null unless this render actually put the thing
// on screen, which is what src/mixins/seo.js keys the Product node on.
export default {
  computed: {
    ...mapGetters('eShop', ['cards']),
    ...mapGetters('reviews', ['averageRating', 'reviewsCards']),

    seoSharedSections() {
      return (this.pageData && this.pageData.sharedSections) || {};
    },

    // 16 offers, one per visible row of the calculator. `cards` is the very
    // array that calculator renders and the labels are the keys it prints, so
    // an offer cannot exist without a row a visitor can read.
    seoPassOffers() {
      const offers = buildPassOffers({
        cards: this.cards,
        url: this.seoCanonicalUrl,
        labels: {
          day: this.getTranslatedContent('ESHOP_product_name_DAY'),
          pass: this.getTranslatedContent('ESHOP_product_name_PASS'),
          adult: this.getTranslatedContent('ADULT'),
          studentChild: this.getTranslatedContent('STUDENT_CHILD'),
        },
      });

      return offers.length ? offers : null;
    },

    // The aggregate as the page prints it: same value, same rounding, same
    // count. SharedReviews and the reviews page both render it from these two
    // getters, so the markup and the screen cannot drift apart.
    seoPassRating() {
      return buildProductRating({
        value: this.averageRating && Number(this.averageRating.toFixed(1)),
        count: this.reviewsCards.length,
      });
    },
  },
};
